<div class="space-y-4">
  <!-- Card: General -->
  <div
    class="text-white rounded-xl p-4 shadow-md h-40"
    style="background-color: #1e1d1fb2"
  >
    <h3 class="text-white" style="font-size: 14px">General</h3>
    <app-general-buttons></app-general-buttons>
  </div>

  <!-- Card: Acciones rápidas -->
  <div
    class="rounded-xl p-4 shadow-md relative overflow-hidden h-58"
    style="background-color: #1e1d1fb2"
  >
    <h3 class="text-white" style="font-size: 14px">Acciones rápidas</h3>
    <app-quick-actions-buttons></app-quick-actions-buttons>
  </div>
</div>
